// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__V2mSp","app":"style_app__EfAj5","img":"style_img__eIF_W","header":"style_header__eFtY_"};